// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1b65592b","126":"f89b7ce2","171":"5bdd1f87","173":"ca5c99fe","349":"08f693ed","384":"93bc6c1f","424":"e8cd611a","483":"51d0e4ec","637":"61d424a2","982":"1e5bbc74"}[chunkId] + ".chunk.js";
};